const getLoggedInUserProfile = (state) => state.loggedInUserProfile;

const getSavedLoginError = (state) => state.loginError;

export default {
  getLoggedInUserProfile,
  getSavedLoginError,
};
